<script>
import Admin from "@/components/admin/admin-main-template";
import fc from "@/firebaseConfig";
import _isEqual from "lodash/isEqual";
import { mapState } from "vuex";
import firebase from "firebase/app";
import _ from "lodash";
import { PDFDocument } from "pdf-lib";
import moment from "moment";
import DateRangeSearch from "@/components/admin/documents/date-range-search.vue";
import * as XLSX from "xlsx";
import LoadingAnimation from "@/components/admin/automation/loading-animation.vue";
import ConfirmDocumentDialog from "@/components/admin/automation/confirm-document-dialog.vue";
import ConfirmSingleDocumentDialog from "@/components/admin/automation/confirm-single-document-dialog.vue";
import ConfirmDeleteDialog from "@/components/admin/automation/confirm-delete-dialog.vue";
import { EVENT_TYPES, INVOICE_STATUS } from "@/libs/libConstant";
import logActivity from "@/libs/activityLogger";
import BasicConfirmDialog from "@/components/admin/automation/basic-confirm-dialog.vue";

export default {
  data() {
    return {
      isJustUpdateGlblNumLoc: false,
      companyProduct: "Automate-PO",
      vendorId: "",
      companyId: "",
      purchaseOrders: [], // Full list of purchase orders
      // SAP B1 Settings
      sapB1Settings: {
        username: '',
        passwordEncrypt: ''
      },
      displayedItems: [], // Items to display on the current page
      currentPage: 1, // Current page
      itemsPerPage:
        localStorage.getItem("pageLimit") &&
        localStorage.getItem("pageLimit") === "auto"
          ? 10
          : Number.parseInt(localStorage.getItem("pageLimit")) || 10, // Items per page
      totalItems: 0, // Total number of items
      selectedItems: [], // Selected POIDs
      selectAll: false, // Select all flag
      dialogDelete: false, // Dialog for confirmation
      selectedDoc: [], // Selected Docline data (array)
      unsubscribe: null, // Listener to unsubscribe from Firestore updates
      editMode: false, // Flag to track edit mode
      isUpdating: false,
      selectedDocCopy: null,
      dialogConfirmDocument: false,
      dialogConfirmDocumentOne: false,
      purchasePdfFile: null,
      queryText: null,
      isGettingPdfData: false,
      pdfUrl: "",
      isOpenPoDateMenu: false,
      currentPoDate: "",
      PODateDisp: "",
      isOpenDeliveryDateMenu: false,
      currentDeliveryDate: "",
      deliveryDateDisp: "",
      searchPOID: "",
      searchStatus: "SHOW_ALL",
      searchStartDate: null,
      searchEndDate: null,
      poStatus: INVOICE_STATUS,
      statusOptions: [
        { text: "All", value: "SHOW_ALL" },
        { text: "Pending", value: "PENDING_APPROVAL" },
        { text: "Posting", value: "POSTING" },
        { text: "Warning", value: "WARNING" },
        { text: "Error", value: "ERROR" },
      ],
      docStatusList: [
        {
          text: "Pending",
          value: "WAITING_TO_CONFIRM",
          colorClass: "pending-color",
        },
        {
          text: "Pending",
          value: "PENDING_APPROVAL",
          colorClass: "pending-color",
        },
        {
          text: "Posting",
          value: "CONFIRMED",
          colorClass: "posting-color",
        },
        {
          text: "Posting",
          value: "POSTING",
          colorClass: "posting-color",
        },
        {
          text: "Warning",
          value: "FAILURE",
          colorClass: "warning-color",
        },
        {
          text: "Warning",
          value: "PO_FAILURE",
          colorClass: "warning-color",
        },
        {
          text: "Warning",
          value: "WARNING",
          colorClass: "warning-color",
        },
        {
          text: "Error",
          value: "SO_FAILURE",
          colorClass: "error-color",
        },
        {
          text: "Error",
          value: "ERROR",
          colorClass: "error-color",
        },
        {
          text: "Success",
          value: "SUCCESS",
          colorClass: "success-color",
        },
      ],
      docToDelete: null,
      isOpenCustomDialogue: false,
      dialogRefreshDocument: false,
      // Export Dialog
      exportDialog: false,
      isExporting: false,
      menuDatePickerStart: false,
      menuDatePickerEnd: false,
      dateExportStart: null,
      dateExportEnd: null,
      exportDocStatus: "SHOW_ALL",
      isLoadingDocs: false,
      isRefreshingDoc: false,
      isConfirmingDoc: false,
      snackbar: {
        show: false,
        msg: "",
        color: "success",
      },
      sortBy: "PODate", // currently sorted column
      sortDirection: "asc", // 'asc' or 'desc'
    };
  },
  name: "documentPOAI",
  components: {
    BasicConfirmDialog,
    DateRangeSearch,
    LoadingAnimation,
    ConfirmDocumentDialog,
    ConfirmSingleDocumentDialog,
    ConfirmDeleteDialog,
    Admin,
  },
  created() {
    let companyId = this.$route.params.companyId;

    if (companyId) {
      this.$store.dispatch("user/getRoleUser", { companyId: companyId });
    }
  },
  methods: {
    handleEscKey(event) {
      // console.log("event.key::", event.key);
      if (event.key === "Escape" || event.key === "Esc") {
        this.isOpenCustomDialogue = false;
      }
    },
    sortTable(column) {
      if (this.sortBy === column) {
        // Toggle sort direction if the column is the same
        this.sortDirection = this.sortDirection === "asc" ? "desc" : "asc";
      } else {
        // Set the new column and default to ascending order
        this.sortBy = column;
        this.sortDirection = "asc";
      }

      // Perform sorting
      this.purchaseOrders.sort((a, b) => {
        let result = 0;
        if (a[column] < b[column]) result = -1;
        if (a[column] > b[column]) result = 1;

        // Reverse if the direction is descending
        return this.sortDirection === "asc" ? result : -result;
      });

      // Paginate sorted items
      this.paginate();
    },

    getDocStatus(value) {
      const docStatus = this.docStatusList.find(
        (status) => status.value === value
      );
      return docStatus;
    },
    getStatusTH(status) {
      return this.getDocStatus(status)?.text;
    },
    getColorClass(status) {
      return this.getDocStatus(status)?.colorClass;
    },
    copyToClipboard(text) {
      navigator.clipboard.writeText(text);
      this.snackbar = {
        show: true,
        color: "success",
        msg: "คัดลอกสำเร็จ",
        icon: "mdi-check",
      };
    },
    isInvalidValue(value) {
      return value === "N/A" || value === 0;
    },
    checkIfInvalid(doclineItem) {
      return (
        this.isInvalidValue(doclineItem.ItemCode) ||
        this.isInvalidValue(doclineItem.ItemName) ||
        this.isInvalidValue(Number(doclineItem.UnitPriceSO)) ||
        this.isInvalidValue(Number(doclineItem.TotalPriceso))
      );
    },
    deleteDocument(doc) {
      this.docToDelete = doc;
      this.dialogDelete = true;
    },
    nAformmater(value) {
      return value === "N/A" ? "" : value;
    },
    debounceInput: _.debounce(function (POID) {
      this.fetchPurchaseOrders();
    }, 1000),
    formatNum(num) {
      if (!num) return "0";

      // Convert to a string to avoid automatic rounding
      let numStr = num.toString();

      // Find the position of the decimal point
      let decimalIndex = numStr.indexOf(".");

      // If there's a decimal point, truncate to two places
      if (decimalIndex !== -1) {
        numStr = numStr.substring(0, decimalIndex + 3);
      }

      // Convert back to a number for locale formatting
      let truncatedNum = Number(numStr);

      return truncatedNum.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    async openPDFFile() {
      this.isGettingPdfData = true;
      // console.log("PDF FILE DOC ID:: ", this.selectedDoc.PDFDocRef);
      const companyID = this.$route.params.companyId;

      const purchasePdfFilesRef = fc.db
        .collection(`Companies/${companyID}/PurchasePdfFiles`)
        .doc(this.selectedDoc.PDFDocRef);

      try {
        const purchasePdfFileSnapshot = await purchasePdfFilesRef.get();

        if (purchasePdfFileSnapshot.exists) {
          const pdfPathGs = purchasePdfFileSnapshot.data().pdfPath;
          // console.log("pdfPathGs:: ", pdfPathGs);

          const callGetPDF = firebase.functions().httpsCallable("callGetPDF");
          const data = { gsPdfPath: pdfPathGs };
          const pdfBase64 = (await callGetPDF(data)).data.httpsPath;

          // Convert Base64 string to Uint8Array
          const byteCharacters = atob(pdfBase64);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);

          // Load the PDF document with pdf-lib
          const pdfDoc = await PDFDocument.load(byteArray);

          // Set the PDF title property
          pdfDoc.setTitle(this.selectedDoc?.POID);

          // Serialize the PDF document to bytes (Uint8Array)
          const pdfBytes = await pdfDoc.save();

          // Create a new Blob from the modified PDF bytes
          const updatedPdfBlob = new Blob([pdfBytes], {
            type: "application/pdf",
          });

          // Create URL for the updated Blob
          const pdfBlobUrl = URL.createObjectURL(updatedPdfBlob);
          this.pdfUrl = pdfBlobUrl;

          // console.log("pdfBlobUrl: ", pdfBlobUrl);
        } else {
          console.log("Document does not exist");
        }
      } catch (error) {
        console.error("Error retrieving PDF file:", error);
      } finally {
        this.isGettingPdfData = false;
      }
    },
    openConfirmDialog() {
      this.dialogConfirmDocument = true;
    },
    openConfirmOneDialog() {
      this.dialogConfirmDocumentOne = true;
    },
    openRefreshDocument() {
      this.dialogRefreshDocument = true;
    },
    toggleEditMode() {
      if (!this.editMode) {
        // Create a temporary copy of the selected document
        this.selectedDocCopy = Object.assign({}, this.selectedDoc);
      } else {
        // If cancel is clicked, revert back to the temporary copy
        this.selectedDoc = Object.assign({}, this.selectedDocCopy);
        this.selectedDocCopy = null; // Clear the temporary copy
      }
      this.editMode = !this.editMode;
    },
    async refreshPurchasePdfFile() {
      this.isRefreshingDoc = true;
      try {
        const companyID = this.$route.params.companyId;
        const purchasePdfFilesRef = fc.db
          .collection(`Companies/${companyID}/PurchasePdfFiles`)
          .doc(this.selectedDoc.PDFDocRef);

        const purchaseOrderRef = fc.db
          .collection(`Companies/${companyID}/PurchaseOrders`)
          .doc(this.selectedDoc.POID);
        await purchaseOrderRef.set(
          {
            Status: "FETCHING",
          },
          { merge: true }
        );

        // console.log("setFetchStatus Success");

        await fc.db.runTransaction(async (transaction) => {
          const docSnapshot = await transaction.get(purchasePdfFilesRef);
          let refreshValue = docSnapshot.data().refresh || 0; // Get current 'refresh' value or default to 0
          refreshValue++;
          transaction.update(purchasePdfFilesRef, { refresh: refreshValue });
        });

        //  console.log('Refreshed the Purchase PDF File.');
      } catch (error) {
        console.error("Error updating the refresh field:", error);
      } finally {
        this.isOpenCustomDialogue = false;
        this.selectedDoc = {};
        this.isRefreshingDoc = false;
      }
    },

    exitEditMode() {
      // Clear the temporary copy and exit edit mode
      this.selectedDocCopy = null;
      this.editMode = false;
    },
    async updateDocument() {
      try {
        // Set updating to true to indicate update in progress
        this.isUpdating = true;

        const companyID = this.$route.params.companyId;
        // Update the document in Firebase with new values
        const docRef = fc.db
          .collection(`Companies/${companyID}/PurchaseOrders`)
          .doc(this.selectedDoc.POID);
        await docRef.update({
          ...this.selectedDoc,
          // Status: INVOICE_STATUS.PENDING_APPROVAL,
          // PoDate: this.PoDateDisp,
          isChangeGlblLocNum:
            this.selectedDoc.GlblLocNum !== this.selectedDocCopy.GlblLocNum,
        });

        this.isJustUpdateGlblNumLoc =
          this.selectedDoc.GlblLocNum !== this.selectedDocCopy.GlblLocNum;
        // Update successful
        // console.log("Document updated successfully!");
        this.exitEditMode();
        this.snackbar = {
          show: true,
          msg: "บันทึกเอกสารสำเร็จ",
          color: "success",
        };

        // Exit edit mode
      } catch (error) {
        // Error handling
        console.error("Error updating document: ", error);
        this.snackbar = {
          show: true,
          msg: "บันทึกเอกสารไม่สําเร็จ!",
          color: "error",
        };
      } finally {
        // Set updating to false regardless of success or failure
        this.editMode = false;
        this.isUpdating = false;
      }
    },
    async confirmDocument() {
      this.isConfirmingDoc = true;
      const companyID = this.$route.params.companyId;

      // Filter selected documents that are pending approval
      const docsToConfirm = this.purchaseOrders.filter(
        (po) =>
          this.selectedItems.includes(po.POID) &&
          po.Status === "PENDING_APPROVAL"
      );

      if (docsToConfirm.length === 0) {
        console.log("No documents are eligible for confirmation.");
        return;
      }

      // Initialize a Firestore batch
      const batch = fc.db.batch();
      const uid = firebase.auth().currentUser.uid;

      docsToConfirm.forEach((selectedDoc) => {
        const purchaseOrdersRef = fc.db
          .collection(`Companies/${companyID}/PurchaseOrders`)
          .doc(selectedDoc.POID);

        batch.set(
          purchaseOrdersRef,
          {
            Status: "POSTING",
            OwnerData: this.user,
            OwnerId: uid,
            TimeUpdate: firebase.firestore.FieldValue.serverTimestamp(),
            isChangeGlblLocNum: false,
            sapB1Settings: this.sapB1Settings,
          },
          { merge: true }
        );
      });

      try {
        // Commit the batch write
        await batch.commit();
        // console.log(
        //   "Documents confirmed successfully:",
        //   docsToConfirm.map((doc) => doc.POID)
        // );
      } catch (error) {
        console.error("Error confirming documents:", error);
      } finally {
        // Update UI state once after the batch commit
        this.selectedItems = [];
        this.dialogConfirmDocument = false;
        this.selectAll = false;
        this.isOpenCustomDialogue = false;
        this.isConfirmingDoc = false;
      }

      // Refresh the purchase orders to reflect the changes
      this.fetchPurchaseOrders();
    },
    async confirmDocumentOne() {
      this.isConfirmingDoc = true;
      const companyID = this.$route.params.companyId;
      const uid = firebase.auth().currentUser.uid;

      // Iterate over each document eligible for confirmation
      const purchaseOrdersRef = fc.db
        .collection(`Companies/${companyID}/PurchaseOrders`)
        .doc(this.selectedDoc.POID);

      try {
        // Update the status of the current document to "CONFIRMED"
        await purchaseOrdersRef.set(
          {
            Status: "POSTING",
            TimeUpdate: firebase.firestore.FieldValue.serverTimestamp(),
            isChangeGlblLocNum: false,
            OwnerData: this.user,
            OwnerId: uid,
            sapB1Settings: this.sapB1Settings,
          },
          { merge: true }
        );

        this.snackbar = {
          show: true,
          msg: "ยืนยันเอกสารสำเร็จ",
          color: "success",
        };
      } catch (error) {
        console.error(
          `Error confirming document with POID ${this.selectedDoc.POID}:`,
          error
        );
        this.snackbar = {
          show: true,
          msg: "ยืนยันเอกสารไม่สำเร็จ",
          color: "error",
        };
      } finally {
        this.selectedDoc = {};
        this.dialogConfirmDocumentOne = false;
        this.isConfirmingDoc = false;
      }

      // Fetch purchase orders to reflect the changes
      this.fetchPurchaseOrders();

      // Close the confirmation dialog
      this.isOpenCustomDialogue = false;
    },
    async fetchPurchaseOrders() {
      this.isLoadingDocs = true;
      try {
        // console.log("fetchPurchaseOrders");
        const { searchPOID, searchStatus, searchStartDate, searchEndDate } =
          this;
        // console.log(searchPOID, searchStatus, searchStartDate, searchEndDate);

        const defaultStatusList = [
          "FAILURE",
          "PO_FAILURE",
          "SO_FAILURE",
          "CONFIRMED",
          "WAITING_TO_CONFIRM",
          "PENDING_APPROVAL",
          "POSTING",
          "WARNING",
          "ERROR",
          "",
        ];

        const companyID = this.$route.params.companyId;
        let query = fc.db.collection(`Companies/${companyID}/PurchaseOrders`);

        // Array to hold orderBy fields
        const orderByFields = [];

        // Filter by POID
        if (searchPOID) {
          // const endKey = `${searchPOID}\uf8ff`;
          // query = query
          //   .where("POID", ">=", searchPOID)
          //   .where("POID", "<=", endKey);
          query = query.where("POID", "==", searchPOID);
          orderByFields.push("POID");
        }

        // Filter by Status
        const statusList =
          !searchStatus || searchStatus === "SHOW_ALL"
            ? defaultStatusList
            : [searchStatus];
        // console.log("statusList::", statusList);
        query = query.where("Status", "in", statusList);

        // Filter by VendorID
        const vendorID = this.$route.params.vendorId;
        if (vendorID) {
          query = query.where("CompanyCode", "==", vendorID);
        }

        // Filter by PODate
        if (searchStartDate) {
          const start = new Date(searchStartDate);
          start.setHours(0);

          const end = searchEndDate
            ? new Date(searchEndDate)
            : new Date(searchStartDate);
          end.setHours(23, 59, 59, 999);

          query = query.where("PODate", ">=", start);
          query = query.where("PODate", "<=", end);
          // Ensure 'PODate' is the first orderBy if used
          // console.log("start:: ", start);
          // console.log("end:: ", end);
        }
        orderByFields.unshift("PODate");

        // console.log("orderByFields:: ", orderByFields);
        // Apply orderBy clauses in sequence
        orderByFields.forEach((field) => {
          query = query.orderBy(field, "desc");
        });

        // Handle unsubscribe to prevent memory leaks
        if (this.unsubscribe) {
          this.unsubscribe();
        }

        this.unsubscribe = query.onSnapshot((snapshot) => {
          this.purchaseOrders = snapshot.docs.map((doc) => doc.data());
          this.totalItems = this.purchaseOrders.length;
          this.currentPage = 1; // Reset to first page
          this.paginate(); // Initial pagination
          this.isLoadingDocs = false;
        });
      } catch (error) {
        console.error("Error fetching purchase orders:", error);
        this.isLoadingDocs = false;
      }
    },
    paginate() {
      const totalPages = this.numPages;
      if (this.currentPage > totalPages) {
        this.currentPage = totalPages || 1; // Set to last page or 1 if no items
      }
      const startIndex = (this.currentPage - 1) * this.itemsPerPage;
      const endIndex = startIndex + this.itemsPerPage;
      this.displayedItems = this.purchaseOrders.slice(startIndex, endIndex);

      // Clear selection
      this.selectedItems = [];
      this.selectAll = false;
    },
    toggleAll() {
      if (this.selectAll) {
        this.selectedItems = this.displayedItems
          .filter((item) => item.Status === this.poStatus.PENDING_APPROVAL)
          ?.map((item) => item.POID);
      } else {
        this.selectedItems = [];
      }
    },
    getCheckboxValue(item) {
      return `${item.POID}`;
    },
    handleStatusSearch() {
      this.fetchPurchaseOrders();
    },
    confirmDelete() {
      this.dialogDelete = true;
    },
    async deleteSelectedItem() {
      // Delete selected items by their POIDs
      // console.log("this.docToDelete:: ", this.docToDelete.POID);
      const POID = this.docToDelete.POID;
      try {
        const companyID = this.$route.params.companyId;
        await fc.db
          .collection(`Companies/${companyID}/PurchaseOrders`)
          .doc(POID)
          .set(
            {
              Status: "DELETED",
            },
            { merge: true }
          );
      } catch (error) {
        console.error(`Error deleting item with POID ${POID}:`, error);
      }
      // After deletion, clear selected items
      // No need to refetch data, as it updates in real-time
      // Close the confirmation dialog
      this.dialogDelete = false;
    },
    setNewDocStatus() {
      const companyID = this.$route.params.companyId;
      const purchaseOrdersRef = fc.db
        .collection(`Companies/${companyID}/PurchaseOrders`)
        .doc(this.selectedDoc.POID);
      purchaseOrdersRef.set(
        {
          Status: "NEW",
          isChangeGlblLocNum: false,
        },
        { merge: true }
      );
      this.isOpenCustomDialogue = false;
      this.isJustUpdateGlblNumLoc = false;
    },
    // Method to show Docline details dialog
    showDocDetailDialog(doc) {
      this.isOpenCustomDialogue = true;
      this.selectedDoc = {
        ...doc,
        Remark: doc.Remark !== "N/A" ? doc.Remark : "",
        VAT: (Number(doc.SubTotalSO) * 0.07).toFixed(2),
        Doctotal: (
          Number(doc.SubTotalSO) +
          Number(doc.SubTotalSO) * 0.07
        ).toFixed(2),
      };
    },
    resetSearchConfig() {
      this.searchPOID = "";
      this.searchStatus = "SHOW_ALL";
      this.searchStartDate = null;
      this.searchEndDate = null;
    },
    getThaiDate(timestamp) {
      if (!timestamp) return "N/A";
      moment.locale("th");

      const date = new Date(timestamp.seconds * 1000);

      // Format the date with Thai month and Buddhist year
      const formattedDate = moment(date).add(543, "years").format("DD MMM YY");

      return formattedDate;
    },
    async fetchPurchaseOrdersByDateRange(fromDate, toDate) {
      // console.log("fromDate::", fromDate);
      // console.log("toDate::", toDate);
      this.searchStartDate = fromDate;
      this.searchEndDate = toDate;
      await this.fetchPurchaseOrders();
    },
    resetDateSearch() {
      this.resetSearchConfig();
      this.fetchPurchaseOrders();
    },
    cancelExportDocs() {
      this.exportDialog = false;
      // this.$refs.form.reset();
      this.dateExportEnd = "";
      this.dateExportStart = "";
      this.exportDocStatus = "SHOW_ALL";
    },
    async exportDocs() {
      if (!this.dateExportStart) {
        this.snackbar = {
          show: true,
          color: "error",
          msg: "กรุณาเลือกวันที่เริ่มต้น",
        };

        return;
      }
      if (!this.dateExportEnd) {
        this.snackbar = {
          show: true,
          color: "error",
          msg: "กรุณาเลือกวันที่สิ้นสุด",
        };

        return;
      }

      const startDate = new Date(this.dateExportStart);
      startDate.setHours(0);
      const endDate = new Date(this.dateExportEnd);
      endDate.setHours(23, 59, 59, 999);
      const status = this.exportDocStatus;

      if (startDate > endDate) {
        this.snackbar = {
          show: true,
          color: "error",
          msg: "วันที่เริ่มต้นต้องน้อยกว่าวันที่สิ้นสุด",
        };
        return;
      }

      let query = fc.db.collection(
        `Companies/${this.companyId}/PurchaseOrders`
      );
      if (status !== "SHOW_ALL") {
        query = query.where("Status", "==", status);
      } else {
        query = query.where("Status", "in", [
          "PENDING_APPROVAL",
          "POSTING",
          "WARNING",
        ]);
      }
      if (this.vendorId) {
        query = query.where("CompanyCode", "==", this.vendorId);
      }
      query = query
        .where("PODate", ">=", startDate)
        .where("PODate", "<=", endDate);
      const exportData = [];

      await query.get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          const temp = doc.data();
          delete temp.Docline;
          exportData.push({
            [`สถานะเอกสาร (Status)`]: this.getStatusTH(temp.Status),
            [`วันที่เอกสารใบสั่งซื้อ (PO Date)`]: this.getThaiDate(temp.PODate),
            [`เลขที่เอกสารใบสั่งซื้อ (PO No.)`]: temp.POID,
            [`รหัสลูกค้า (Customer Code)`]: temp.CardCode,
            [`ชื่อลูกค้า (Customer Name)`]: temp.CardNameTH,
            [`รหัสสาขา (Branch Code)`]: temp.GlblLocNum,
            [`สาขาลูกค้า (Branch Name)`]: temp.BranchNameTH,
            [`มูลค่าก่อนภาษี (Price Before Vat)`]: this.formatNum(
              temp.SubTotalSO
            ),
            [`ภาษีมูลค่าเพิ่ม (Vat)`]: this.formatNum(temp.VAT),
            [`มูลค่ารวม (Total)`]: this.formatNum(temp.Doctotal),
            [`สถานที่ส่งสินค้า (Ship To)`]: temp.ShipTo,
            [`หมายเหตุ (Remark)`]: temp.Remark,
          });
        });
      });

      if (exportData.length === 0) {
        this.snackbar = {
          show: true,
          color: "error",
          msg: "ไม่พบข้อมูลที่ต้องการส่งออก กรุณาเลือกระยะเวลาใหม่",
        };
        return;
      }
      const header = Object.keys(exportData[0]);

      // console.log("exportData:: ", exportData);

      const worksheet = XLSX.utils.json_to_sheet(exportData, {
        header: header,
      });

      const workbook = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(workbook, worksheet, "PurchaseOrders");

      const fileName = `PurchaseOrders_${new Date()
        .toISOString()
        .slice(0, 10)}.xlsx`;

      XLSX.writeFile(workbook, fileName);
    },
    intPage() {
      this.vendorId = this.$route.params?.vendorId || "";
      this.companyId = this.$route.params?.companyId || "";
    },
    
    loadSapB1Settings() {
      // Load SAP B1 settings for this user in this company
      const userId = fc.auth.currentUser?.uid;
      const companyId = this.$router.currentRoute.params.companyId;
      
      if (userId && companyId) {
        const userPath = `/Users/${userId}/SapB1Settings/${companyId}`;
        const settingDoc = fc.db.doc(userPath);
        
        settingDoc.get().then((snapshot) => {
          if (snapshot.exists) {
            const data = snapshot.data();
            this.sapB1Settings = {
              username: data.username || '',
              passwordEncrypt: data.passwordEncrypt || ''
            };
          }
        }).catch((error) => {
          console.error('Error loading SAP B1 settings:', error);
        });
      }
    },
    openExternalFirebaseLink() {
      try {
        const hrefLink = `https://console.firebase.google.com/project/sld-etax/firestore/databases/-default-/data/~2FCompanies~2F${this.$route.params.companyId}~2FPurchaseOrders~2F${this.selectedDoc.POID}`;
        window.open(hrefLink, "_blank");
      } catch (error) {
        console.error("Error opening external Firebase link:", error);
      }
    },

    downloadExtractedText(poID) {
      // console.log("POID", poID);

      fc.db
        .collection(
          `Companies/${this.companyId}/PurchaseOrders/${poID}/ExtractedText`
        )
        .orderBy("@timeCreate", "desc")
        .limit(1)
        .get()
        .then((snap) => {
          if (snap.empty) {
            console.log("No extracted text found for POID", poID);

            this.snackbar = {
              show: true,
              color: "error",
              msg: "ไม่พบข้อมูล",
              icon: "mdi-alert-circle-outline",
            };
            return;
          }

          const extractedTextData = snap.docs[0].data();
          // Choose the appropriate field based on your data structure
          const textContent =
            ":::TEXT FROM GOOGLE VISION::: \n\n" +
            (extractedTextData?.extractedTextVision || "-") +
            "\n\n:::TEXT FROM PYTHON CLEANED::: \n\n" +
            (extractedTextData?.extractedText || "-") +
            "\n\n:::TEXT FROM PYTHON ORIGINAL::: \n\n" +
            (extractedTextData?.backupExtractedText || "-");

          if (!textContent) {
            console.log("No text content available to download.");
            return;
          }

          // Prepare the text content
          let fileContent = "";
          if (Array.isArray(textContent)) {
            fileContent = textContent.join("\n");
          } else if (typeof textContent === "string") {
            fileContent = textContent;
          } else {
            fileContent = JSON.stringify(textContent, null, 2);
          }

          // Create a Blob from the text content
          const blob = new Blob([fileContent], { type: "text/plain" });
          const url = URL.createObjectURL(blob);

          // Create a temporary anchor element to trigger the download
          const a = document.createElement("a");
          a.href = url;
          a.download = `TextExtracted_PO_${poID}.txt`;
          document.body.appendChild(a);
          a.click();

          // Clean up the temporary elements and revoke the object URL
          document.body.removeChild(a);
          URL.revokeObjectURL(url);

          console.log("Download initiated for POID", poID);
        })
        .catch((err) => {
          console.error("Error fetching extracted text:", err);
        });
    },
    downloadJson(poID) {
      // console.log("POID", poID);

      fc.db
        .collection(`Companies/${this.companyId}/PurchaseOrders/${poID}/Json`)
        .orderBy("@timeCreate", "desc")
        .limit(1)
        .get()
        .then((snap) => {
          if (snap.empty) {
            console.log("No JSON found for POID", poID);

            this.snackbar = {
              show: true,
              color: "error",
              msg: "ไม่พบข้อมูล",
              icon: "mdi-alert-circle-outline",
            };

            return;
          }

          const jsonData = snap.docs[0].data();
          // Adjust the field name based on your Firestore document structure
          const jsonOutput = jsonData.jsonOutput;

          if (!jsonOutput) {
            console.log("No JSON content available to download.");
            return;
          }

          let fileContent = "";

          if (typeof jsonOutput === "object") {
            // If it's already an object, stringify it
            fileContent = JSON.stringify(jsonOutput, null, 2);
          } else if (typeof jsonOutput === "string") {
            try {
              // If it's a string, try parsing and then stringifying for formatting
              const parsed = JSON.parse(jsonOutput);
              fileContent = JSON.stringify(parsed, null, 2);
            } catch (e) {
              // If parsing fails, use the string as-is
              fileContent = jsonOutput;
            }
          } else {
            // For other data types, convert to JSON string
            fileContent = JSON.stringify(jsonOutput, null, 2);
          }

          // Create a Blob from the JSON content
          const blob = new Blob([fileContent], { type: "application/json" });
          const url = URL.createObjectURL(blob);

          // Create a temporary anchor element to trigger the download
          const a = document.createElement("a");
          a.href = url;
          a.download = `JsonExtracted_PO_${poID}.json`; // Updated filename with .json extension
          document.body.appendChild(a);
          a.click();

          // Clean up the temporary elements and revoke the object URL
          document.body.removeChild(a);
          URL.revokeObjectURL(url);

          console.log("Download initiated for POID", poID);
        })
        .catch((err) => {
          console.error("Error fetching JSON data:", err);
        });
    },
    downloadPdf() {
      if (!this.pdfUrl) {
        this.snackbar = {
          show: true,
          color: "error",
          msg: "ไม่พบไฟล์ PDF",
          icon: "mdi-alert-circle-outline",
        };
        return;
      }

      try {
        // Create a temporary anchor element to trigger the download
        const a = document.createElement("a");
        a.href = this.pdfUrl;
        a.download = `PurchaseOrder_${this.selectedDoc.POID}.pdf`;
        document.body.appendChild(a);
        a.click();

        // Clean up the temporary element
        document.body.removeChild(a);

        this.snackbar = {
          show: true,
          color: "success",
          msg: "ดาวน์โหลด PDF สำเร็จ",
          icon: "mdi-check",
        };

        console.log("Download initiated for POID", this.selectedDoc.POID);
      } catch (error) {
        console.error("Error downloading PDF:", error);
        this.snackbar = {
          show: true,
          color: "error",
          msg: "ดาวน์โหลด PDF ไม่สำเร็จ",
          icon: "mdi-alert-circle-outline",
        };
      }
    },
  },
  computed: {
    ...mapState({
      selectedCompanyAutoDocConfig: (state) =>
        state.companies.selectedCompanyAutoDocConfig,
      user: (state) => state.user.userData,
      userCompany: (state) => state.user.userCompany,
      selectedCompanyProductList: (state) =>
        state.companies.selectedCompanyProductList,
      isProductListLoading: (state) => state.companies.isProductListLoading,
    }),
    itemsRangeText() {
      const start = (this.currentPage - 1) * this.itemsPerPage + 1;
      const end = Math.min(
        this.currentPage * this.itemsPerPage,
        this.totalItems
      );
      return `${start} - ${end} จาก ${this.totalItems}`;
    },
    formattedPODate() {
      if (this.selectedDoc?.PODate instanceof Date) {
        const parts = this.selectedDoc?.PODate.toLocaleDateString().split("/");
        // Rearrange the parts to form the desired format
        const formattedDate = `${parts[2]}-${parts[0]?.padStart(
          2,
          "0"
        )}-${parts[1]?.padStart(2, "0")}`;

        return formattedDate;
      }
      var milliseconds =
        this.selectedDoc?.PODate?.seconds * 1000 +
        this.selectedDoc?.PODate?.nanoseconds / 1000000 +
        100;

      // Create a JavaScript Date object from milliseconds
      var date = new Date(milliseconds);
      const parts = date.toLocaleDateString().split("/");
      // Rearrange the parts to form the desired format
      const formattedDate = `${parts[2]}-${parts[0]?.padStart(
        2,
        "0"
      )}-${parts[1]?.padStart(2, "0")}`;

      return formattedDate;
    },
    formattedDeliveryDate() {
      if (
        !this.selectedDoc?.DeliveryDate ||
        this.selectedDoc?.DeliveryDate === "Invalid Date"
      )
        return "";

      console.log(
        "this.selectedDoc?.DeliveryDate:: ",
        this.selectedDoc?.DeliveryDate
      );

      if (this.selectedDoc?.DeliveryDate instanceof Date) {
        const parts =
          this.selectedDoc?.DeliveryDate.toLocaleDateString().split("/");
        // Rearrange the parts to form the desired format
        const formattedDate = `${parts[2]}-${parts[0]?.padStart(
          2,
          "0"
        )}-${parts[1]?.padStart(2, "0")}`;

        return formattedDate;
      }
      var milliseconds =
        this.selectedDoc?.DeliveryDate?.seconds * 1000 +
        this.selectedDoc?.DeliveryDate?.nanoseconds / 1000000 +
        100;

      // Create a JavaScript Date object from milliseconds
      var date = new Date(milliseconds);
      const parts = date.toLocaleDateString().split("/");
      // Rearrange the parts to form the desired format
      const formattedDate = `${parts[2]}-${parts[0]?.padStart(
        2,
        "0"
      )}-${parts[1]?.padStart(2, "0")}`;

      return formattedDate;
    },
    formattedVAT() {
      // Format the VAT value using Intl.NumberFormat
      return this.formatNum(this.selectedDoc.VAT);
    },
    formattedSubTotal() {
      // Format the VAT value using Intl.NumberFormat
      return this.formatNum(this.selectedDoc.SubTotal);
    },
    formattedSubTotalSO() {
      // Format the VAT value using Intl.NumberFormat
      return this.formatNum(this.selectedDoc.SubTotalSO);
    },
    formattedDiscount() {
      // Format the VAT value using Intl.NumberFormat
      return this.formatNum(this.selectedDoc.Discount);
    },
    formattedDoctotal() {
      // Format the VAT value using Intl.NumberFormat
      return this.formatNum(this.selectedDoc.Doctotal);
    },
    numPages() {
      return Math.ceil(this.totalItems / this.itemsPerPage);
    },
    areItemsSelected() {
      return this.selectedItems.length > 0;
    },
    isDocUnchanged() {
      if (!this.selectedDoc.GlblLocNum) return true;
      return _isEqual(this.selectedDoc, this.selectedDocCopy);
    },
    currentVendor() {
      return this.selectedCompanyAutoDocConfig.find(
        (item) => item.vendorCode === this.$route.params.vendorId
      );
    },
    areDocsEligibleForConfirmation() {
      // Check if there are selected documents and if all of them have a status other than "SUCCESS"
      // console.log("selectedItems:: 2 ", this.selectedItems);
      return (
        this.selectedItems?.length > 0 &&
        this.purchaseOrders
          ?.filter((po) => this.selectedItems.includes(po.POID))
          ?.every((doc) => doc.Status === "PENDING_APPROVAL")
      );
    },
    indeterminate() {
      return (
        this.selectedItems.length > 0 &&
        this.selectedItems.length <
          this.displayedItems.filter(
            (item) => item.Status === this.poStatus.PENDING_APPROVAL
          ).length
      );
    },
  },
  watch: {
    currentPage() {
      this.paginate();
    },
    selectedDoc() {
      this.currentPoDate = this.formattedPODate;
      this.currentDeliveryDate = this.formattedDeliveryDate;
    },
    currentPoDate() {
      if (!this.currentPoDate) return;
      // Split the date string into year, month, and day
      const parts = this.currentPoDate.split("-");
      // Rearrange the parts to form the desired format
      this.PODateDisp = `${parts[2]}/${parts[1]}/${parts[0]}`;
      this.selectedDoc.PODate = new Date(this.currentPoDate);
    },
    currentDeliveryDate(newVal) {
      // runs even when newVal === ''
      if (!newVal) {
        // ← guard for cleared/empty value
        this.deliveryDateDisp = "";
        return;
      }
      const [yyyy, mm, dd] = newVal.split("-");
      this.deliveryDateDisp = `${dd}/${mm}/${yyyy}`;
      // always write *valid* date into the doc
      this.$set(this.selectedDoc, "DeliveryDate", new Date(newVal));
    },
    isOpenCustomDialogue(oldValue, newValue) {
      if (newValue === false) {
        this.pdfUrl = "";
        this.openPDFFile();
        this.editMode = false;
      }
    },
    selectAll(oldValue, newValue) {
      this.toggleAll();
    },
    $route: {
      handler() {
        this.intPage();
        // console.log("vendorId:: ", this.vendorId);
        // console.log("companyId:: ", this.companyId);

        this.resetSearchConfig();
        this.fetchPurchaseOrders();
      },
      deep: true,
    },
    dateExportStart() {
      if (!this.dateExportEnd) {
        this.dateExportEnd = this.dateExportStart;
      }
      if (this.dateExportEnd < this.dateExportStart) {
        this.dateExportEnd = this.dateExportStart;
      }
    },
  },
  mounted() {
    logActivity("page_view", { page_title: "DocumentPOAI" });
    this.intPage();
    let { status = "", startDate = "", endDate = "" } = this.$route.query;
    // console.log("startDate -->", startDate);
    // console.log("endDate -->", endDate);
    // console.log("status -->", status);

    if (status) {
      this.searchStatus = status;
    }

    if (startDate) {
      this.searchStartDate = startDate;
    }

    if (endDate) {
      this.searchEndDate = endDate;
    }

    this.fetchPurchaseOrders();
    this.loadSapB1Settings();
    window.addEventListener("keydown", this.handleEscKey);
  },
  beforeDestroy() {
    // Unsubscribe from Firestore updates when component is destroyed
    if (this.unsubscribe) {
      this.unsubscribe();
    }

    window.removeEventListener("keydown", this.handleEscKey);
  },
};
</script>

<template>
  <Admin style="background: white">
    <v-main class="wrapper">
      <v-container fluid>
        <v-card>

          <basic-confirm-dialog
            :is-open="dialogRefreshDocument"
            topic="การดึงข้อมูลอีกครั้ง"
            @update:isOpen="dialogRefreshDocument = $event"
            @confirm="refreshPurchasePdfFile"
          />

          <!-- Confirmation Dialog for Single Document -->
          <confirm-single-document-dialog
            :is-open="dialogConfirmDocumentOne"
            @update:isOpen="dialogConfirmDocumentOne = $event"
            @confirm="confirmDocumentOne"
          />

          <!-- Confirmation Dialog for Multiple Documents -->
          <confirm-document-dialog
            :is-open="dialogConfirmDocument"
            :selected-items="selectedItems"
            @update:isOpen="dialogConfirmDocument = $event"
            @confirm="confirmDocument"
          />

          <!-- Delete Confirmation Dialog -->
          <confirm-delete-dialog
            :is-open="dialogDelete"
            :docIdLabel="docToDelete?.POID"
            @update:isOpen="dialogDelete = $event"
            @confirm="deleteSelectedItem"
          />

          <div class="table-container">
            <div v-if="vendorId !== ''" class="ma-4">
              <h3 class="tw-text-base">
                <div
                  class="tw-flex tw-items-center tw-gap-2"
                  v-if="currentVendor?.vendorFullName"
                >
                  <img
                    v-if="currentVendor?.logo"
                    :src="currentVendor?.logo"
                    class="tw-w-8 tw-h-8 tw-object-contain"
                  />

                  <div
                    v-else
                    src="/images/logo.png"
                    class="tw-w-8 tw-h-8 tw-object-contain tw-bg-gray-50 tw-rounded tw-flex tw-items-center tw-justify-center"
                  >
                    <v-icon size="24">mdi-city</v-icon>
                  </div>

                  {{ currentVendor?.vendorFullName }} - เลขที่ผู้เสียภาษี
                  {{ currentVendor?.taxId }}
                </div>
                <span v-else
                  ><v-icon size="32">mdi-city</v-icon>
                  <v-icon class="mdi-spin">mdi-refresh</v-icon></span
                >
              </h3>
            </div>
            <hr v-if="vendorId !== ''" class="tw-mx-4 tw-pt-2 tw-opacity-10" />
            <div class="pt-8 table-toolbar">
              <v-row class="px-3 pa-0 tw-gap-4">
                <v-col cols="3" class="pa-0">
                  <div class="tw-flex tw-gap-2">
                    <v-btn
                      color="primary"
                      class="py-4 tw-text-sm tw-tracking-normal"
                      @click="openConfirmDialog"
                      :disabled="
                        !areItemsSelected || !areDocsEligibleForConfirmation
                      "
                      elevation="0"
                    >
                      <v-icon left>mdi-check</v-icon>
                      ยืนยันเอกสาร
                    </v-btn>
                    <v-btn
                      color="primary"
                      class="py-4 tw-text-sm tw-tracking-normal"
                      outlined
                      @click="exportDialog = true"
                      elevation="0"
                    >
                      <v-icon left>mdi-table-arrow-right</v-icon>
                      ส่งออกข้อมูล
                    </v-btn>
                  </div>
                </v-col>
                <v-spacer></v-spacer>
                <template>
                  <v-col class="tw-flex pa-0" cols="2">
                    <v-text-field
                      class="ma-0 pa-0 tw-text-sm"
                      label="ค้นหาเลขที่เอกสาร"
                      dense
                      append-icon="mdi-magnify"
                      v-model="searchPOID"
                      @input="(n) => debounceInput(n, null)"
                      outlined
                    ></v-text-field>
                  </v-col>
                </template>
                <v-col class="pa-0" cols="2">
                  <v-select
                    v-model="searchStatus"
                    :items="statusOptions"
                    label="สถานะเอกสาร"
                    dense
                    v-on:change="handleStatusSearch"
                    outlined
                  ></v-select>
                </v-col>
                <v-col class="pa-0" cols="4">
                  <date-range-search
                    outline
                    :initial-from-date="searchStartDate"
                    :initial-to-date="searchEndDate"
                    :on-reset="resetDateSearch"
                    :on-search="fetchPurchaseOrdersByDateRange"
                  />
                </v-col>
              </v-row>
            </div>
            <table class="custom-table tw-text-sm">
              <thead>
                <tr>
                  <th>
                    <v-checkbox
                      class="ma-0 pa-0 tw-transform tw-translate-y-3"
                      v-model="selectAll"
                      color="primary"
                    ></v-checkbox>
                  </th>
                  <th>สถานะเอกสาร <br />(Status)</th>
                  <th class="tw-cursor-pointer" @click="sortTable('PODate')">
                    วันที่เอกสาร<br />(PO Date)
                    <!-- Only show the icon if this column is currently sorted -->
                    <v-icon v-if="sortBy === 'PODate'">
                      {{
                        sortDirection === "asc"
                          ? "mdi-chevron-up"
                          : "mdi-chevron-down"
                      }}
                    </v-icon>
                  </th>
                  <th class="tw-cursor-pointer" @click="sortTable('POID')">
                    เลขที่เอกสารใบสั่งซื้อ<br />(PO No.)
                    <!-- Only show the icon if this column is currently sorted -->
                    <v-icon v-if="sortBy === 'POID'">
                      {{
                        sortDirection === "asc"
                          ? "mdi-chevron-up"
                          : "mdi-chevron-down"
                      }}
                    </v-icon>
                  </th>
                  <th class="tw-cursor-pointer" @click="sortTable('CardCode')">
                    รหัสลูกค้า<br />(Customer Code)
                    <!-- Only show the icon if this column is currently sorted -->
                    <v-icon v-if="sortBy === 'CardCode'">
                      {{
                        sortDirection === "asc"
                          ? "mdi-chevron-up"
                          : "mdi-chevron-down"
                      }}
                    </v-icon>
                  </th>
                  <th>ชื่อลูกค้า <br />(Customer Name)</th>
                  <th>สาขาลูกค้า <br />(Branch Name)</th>
                  <th class="tw-text-right">
                    มูลค่าก่อนภาษี <br />(Price Before Vat)
                  </th>
                  <th class="tw-text-right">ภาษีมูลค่าเพิ่ม <br />(Vat)</th>
                  <th class="tw-text-right">มูลค่ารวม <br />(Total)</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, index) in displayedItems"
                  :key="index"
                  @click="showDocDetailDialog(item)"
                >
                  <td @click.stop>
                    <v-checkbox
                      v-if="item.Status === poStatus.PENDING_APPROVAL"
                      class="ma-0 pa-0 tw-transform tw-translate-y-3"
                      v-model="selectedItems"
                      :value="getCheckboxValue(item)"
                    ></v-checkbox>
                  </td>
                  <td class="tw-text-xs">
                    <v-tooltip
                      top
                      v-if="
                        item.FailureMessage !== '' &&
                        item.FailureMessage !== 'N/A'
                      "
                    >
                      <template v-slot:activator="{ on }">
                        <div
                          v-on="on"
                          :class="`status-card ${getColorClass(item.Status)}`"
                        >
                          {{ getStatusTH(item.Status) }}
                        </div>
                      </template>
                      <span>{{ item.FailureMessage }}</span>
                    </v-tooltip>
                    <div
                      v-else
                      :class="`status-card ${getColorClass(item.Status)}`"
                    >
                      {{ getStatusTH(item.Status) }}
                    </div>
                  </td>
                  <td>{{ getThaiDate(item.PODate) }}</td>
                  <!-- click here to copy POID -->
                  <td @click.stop>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <span
                          v-on="on"
                          @click="copyToClipboard(item.POID)"
                          class="hover:tw-opacity-70"
                          style="user-select: none"
                        >
                          {{ item.POID }}
                        </span>
                      </template>
                      <span>
                        <v-icon color="white">mdi-content-copy</v-icon>
                        คลิกเพื่อคัดลอก</span
                      >
                    </v-tooltip>
                  </td>
                  <td>{{ item.CardCode }}</td>
                  <td>{{ item.CardNameTH }}</td>
                  <td>{{ item.BranchNameTH }}</td>
                  <td class="tw-text-right">
                    {{ formatNum(item.SubTotalSO) }}
                  </td>
                  <td class="tw-text-right">
                    {{ formatNum(Number(item.SubTotalSO * 0.07).toFixed(2)) }}
                  </td>
                  <td class="tw-text-right">
                    {{
                      formatNum(
                        (
                          Number(item.SubTotalSO) +
                          Number(item.SubTotalSO) * 0.07
                        ).toFixed(2)
                      )
                    }}
                  </td>
                  <td>
                    <!-- delete button  -->
                    <v-btn
                      v-if="item.Status !== poStatus.POSTING"
                      icon
                      color="error"
                      class="tw-text-lg"
                      @click.stop="deleteDocument(item)"
                    >
                      <v-icon class="">mdi-delete</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </tbody>
            </table>
            <div
              v-if="purchaseOrders.length === 0 && !isLoadingDocs"
              class="tw-text-center tw-w-full tw-opacity-80 tw-py-40"
            >
              <h2>ไม่พบเอกสารที่ต้องการ</h2>
            </div>
            <v-progress-linear
              indeterminate
              color="green"
              :active="isLoadingDocs"
            ></v-progress-linear>
          </div>
          <!-- Pagination Controls -->
        </v-card>
        <v-row justify="start" class="tw-my-4">
          <div class="tw-px-4">
            {{ itemsRangeText }}
          </div>
          <v-spacer />
          <v-pagination
            v-model="currentPage"
            :length="numPages"
            :total-visible="6"
            @input="paginate"
          ></v-pagination>
          <v-spacer />
        </v-row>
      </v-container>

      <div v-if="isOpenCustomDialogue" class="custom-dialogue">
        <div if="selectedDoc" class="custom-dialogue-content-wrapper">
          <!-- header title  -->
          <div class="dialog-header-wrapper">
            <div class="tw-flex tw-justify-center">
              <span
                :class="`status-card-dialogue tw-text-sm  ${getColorClass(
                  selectedDoc.Status
                )} `"
              >
                {{ getStatusTH(selectedDoc.Status) }}
              </span>
            </div>
          </div>
          <!-- content  -->
          <div class="dialog-content-wrapper">
            <div
              class="dialog-content-left tw-rounded-lg tw-overflow-hidden tw-border-2 tw-bg-pdf-gray"
            >
              <embed
                v-if="!isGettingPdfData"
                :src="pdfUrl + '#toolbar=0&navpanes=0&scrollbar=0'"
                type="application/pdf"
                width="100%"
                height="100%"
              />
              <div
                v-else
                class="tw-h-full tw-w-full tw-flex tw-justify-center tw-items-center"
              >
                <LoadingAnimation />
              </div>
            </div>
            <div class="dialog-content-right">
              <div
                class="tw--translate-y-4 tw-tracking-tight tw-transform tw-pt-10 tw-h-full tw-overflow-y-scroll"
              >
                <v-row class="mx-2">
                  <v-col cols="9" xs="12" class="py-0">
                    <v-text-field
                      class="ma-0 pa-0"
                      label="ชื่อลูกค้า (Customer Name)"
                      dense
                      persistent-placeholder
                      readonly
                      :disabled="editMode"
                      :value="selectedDoc.CardNameTH"
                      outlined
                    ></v-text-field>
                  </v-col>
                  <v-col cols="3" xs="12" class="py-0">
                    <v-text-field
                      required
                      dense
                      class="ma-0 pa-0"
                      :readonly="!editMode"
                      maxlength="5"
                      label="รหัสสาขา (Branch Code) *"
                      persistent-placeholder
                      :rules="[(v) => !!v || 'กรุณากรอกรหัสสาขา']"
                      v-model="selectedDoc.GlblLocNum"
                      outlined
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row class="mx-2">
                  <v-col cols="6" class="py-0"
                    ><v-text-field
                      dense
                      label="เลขที่ใบสั่งซื้อ (PO Number)"
                      v-model="selectedDoc.POID"
                      persistent-placeholder
                      outlined
                      :disabled="editMode"
                      readonly
                    ></v-text-field
                  ></v-col>
                  <v-col cols="3" class="py-0">
                    <v-menu
                      v-model="isOpenPoDateMenu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      max-width="292px"
                      min-width="292px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          label="วันที่ใบสั่งซื้อ (PO Date)"
                          append-icon="mdi-calendar-month-outline"
                          persistent-placeholder
                          readonly
                          dense
                          :value="PODateDisp"
                          outlined
                          v-on="editMode ? on : {}"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        dense
                        color="primary"
                        locale="en-in"
                        v-model="currentPoDate"
                        no-title
                        @input="isOpenPoDateMenu = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="3" class="py-0">
                    <v-menu
                      v-model="isOpenDeliveryDateMenu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      max-width="292px"
                      min-width="292px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          label="วันที่ส่งของ (Delivery Date)"
                          append-icon="mdi-calendar-month-outline"
                          persistent-placeholder
                          readonly
                          dense
                          :value="deliveryDateDisp"
                          outlined
                          v-on="editMode ? on : {}"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        dense
                        color="primary"
                        locale="en-in"
                        v-model="currentDeliveryDate"
                        no-title
                        @input="isOpenDeliveryDateMenu = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
                <v-row class="mx-2">
                  <v-col cols="12" xs="12" class="py-0">
                    <v-textarea
                      dense
                      class="ma-0 pa-0"
                      label="สถานที่ส่งสินค้า (Ship To)"
                      persistent-placeholder
                      v-model="selectedDoc.ShipTo"
                      outlined
                      :disabled="editMode"
                      :readonly="!editMode"
                      rows="2"
                    ></v-textarea>
                  </v-col>
                </v-row>

                <div
                  :class="`table-container-detail ${
                    editMode ? 'tw-opacity-50' : ''
                  }`"
                >
                  <table class="mx-5 customer-table-detail tw-text-sm">
                    <thead>
                      <tr>
                        <th>ลำดับ <br />(No.)</th>
                        <th>รหัสสินค้า <br />(Item Code)</th>
                        <th>ชื่อสินค้า <br />(Item Name)</th>
                        <th class="tw-text-right">จำนวน <br />(Qty.)</th>
                        <th class="tw-text-right tw-whitespace-nowrap">
                          ราคาต่อหน่วย <br />(Unit Price)
                        </th>
                      </tr>
                    </thead>
                    <tbody
                      :class="{
                        'tw-text-red-500': checkIfInvalid(doclineItem),
                      }"
                      v-for="(doclineItem, index) in selectedDoc?.Docline"
                      :key="index"
                    >
                      <tr>
                        <td rowspan="2" align="center">{{ index + 1 }}</td>
                        <td>
                          {{ nAformmater(doclineItem.Vendor_ItemCode) }}
                        </td>
                        <td>
                          {{ nAformmater(doclineItem.Vendor_ItemName) }}
                        </td>
                        <td rowspan="2" class="tw-text-center">
                          {{ formatNum(doclineItem.Quantity) }}
                        </td>
                        <td rowspan="2" class="tw-text-right">
                          {{ formatNum(doclineItem.UnitPriceSO) }}
                        </td>
                      </tr>
                      <tr>
                        <td>{{ nAformmater(doclineItem.ItemCode) }}</td>
                        <td>{{ nAformmater(doclineItem.ItemName) }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div class="tw-mb-8 tw-mt-10">
                  <v-row class="mx-2 tw-flex tw-justify-end">
                    <v-col cols="4" xs="12" class="py-0">
                      <!-- <v-text-field
                      v-if="editMode"
                      class="ma-0 pa-0"
                      label="Before VAT"
                      v-model="selectedDoc.SubTotalSO"
                      outlined
                      type="number"
                      reverse
                    ></v-text-field> -->
                      <v-text-field
                        dense
                        class="ma-0 pa-0"
                        label="มูลค่าก่อนภาษี (Price Before Vat)"
                        v-model="formattedSubTotalSO"
                        persistent-placeholder
                        outlined
                        readonly
                        :disabled="editMode"
                        type="text"
                        reverse
                      ></v-text-field>
                    </v-col>
                    <v-col cols="4" xs="12" class="py-0">
                      <!-- <v-text-field
                      v-if="editMode"
                      class="ma-0 pa-0"
                      label="VAT"
                      v-model="selectedDoc.VAT"
                      type="number"
                      reverse
                      outlined
                      :text-right="true"
                    ></v-text-field> -->
                      <v-text-field
                        class="ma-0 pa-0"
                        label="ภาษีมูลค่าเพิ่ม (Vat)"
                        dense
                        reverse
                        :disabled="editMode"
                        readonly
                        v-model="formattedVAT"
                        persistent-placeholder
                        type="text"
                        :text-right="true"
                        outlined
                      ></v-text-field>
                    </v-col>

                    <v-col cols="4" xs="12" class="py-0">
                      <!-- <v-text-field
                      v-if="editMode"
                      class="ma-0 pa-0"
                      label="Total"
                      type="number"
                      v-model="selectedDoc.Doctotal"
                      outlined
                      reverse
                    ></v-text-field> -->
                      <v-text-field
                        dense
                        class="ma-0 pa-0"
                        persistent-placeholder
                        label="มูลค่ารวมทั้งสิ้น (Total)"
                        type="text"
                        readonly
                        v-model="formattedDoctotal"
                        outlined
                        reverse
                        :disabled="editMode"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row class="mx-2">
                    <v-col cols="12" xs="12" class="py-0">
                      <v-textarea
                        class="ma-0 pa-0"
                        label="หมายเหตุ (Remark)"
                        dense
                        :readonly="!editMode"
                        persistent-placeholder
                        v-model="selectedDoc.Remark"
                        outlined
                        rows="3"
                      ></v-textarea>
                    </v-col>
                  </v-row>
                  <!-- REMATCH  MESSAGE  -->
                  <v-row
                    v-if="
                      selectedDoc?.isChangeGlblLocNum || isJustUpdateGlblNumLoc
                    "
                    class="mx-2 tw-mt-12"
                  >
                    <v-col cols="12" xs="12" class="py-0">
                      <label for="">เอกสารมีการแก้ไขเลขที่สาขา</label>
                      <div
                        class="duppBox tw-mt-4 tw-p-4 tw-text-white tw-rounded-2xl"
                      >
                        <p class="ma-0 pa-0">
                          ตรวจพบการแก้ไขเลขที่สาขา กรุณาตรวจแมตช์ข้อมูลใหม่
                        </p>
                      </div>
                    </v-col>
                  </v-row>

                  <v-row
                    v-if="
                      (selectedDoc?.Status === 'ERROR' ||
                        selectedDoc?.Status === 'WARNING') &&
                      selectedDoc?.FailureMessage
                    "
                    class="mx-2 tw-my-12"
                  >
                    <v-col cols="12" xs="12" class="py-0">
                      <label for="">พบข้อผิดพลาด</label>
                      <div
                        :class="`${
                          selectedDoc?.Status === 'ERROR' ? 'errBox' : 'duppBox'
                        } tw-mt-4 tw-p-4 tw-text-white tw-rounded-2xl`"
                      >
                        <p class="ma-0 pa-0">
                          {{ selectedDoc?.FailureMessage }}
                        </p>
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </div>
            </div>
          </div>

          <!-- isJustUpdateGlblNumLoc {{ isJustUpdateGlblNumLoc}} -->
          <div class="dialog-footer-wrapper tw-flex tw-gap-2">
            <v-btn
              v-if="
                this.selectedDoc.Status === 'PENDING_APPROVAL' &&
                !isJustUpdateGlblNumLoc &&
                !this.selectedDoc?.isChangeGlblLocNum
              "
              class="tw-tracking-normal"
              color="primary"
              :disabled="editMode || isUpdating || isRefreshingDoc || isConfirmingDoc"
              @click="openConfirmOneDialog"
            >
              <v-icon left>mdi-check</v-icon>
              ยืนยันเอกสาร</v-btn
            >
            <v-btn
              v-if="
                (this.selectedDoc.Status === 'PENDING_APPROVAL' &&
                  (isJustUpdateGlblNumLoc ||
                    this.selectedDoc?.isChangeGlblLocNum)) ||
                this.selectedDoc.Status === 'WARNING' ||
                this.selectedDoc.Status === 'ERROR'
              "
              color="indigo"
              class="tw-tracking-normal tw-text-white"
              :disabled="editMode || isUpdating || isRefreshingDoc || isConfirmingDoc"
              @click="setNewDocStatus"
            >
              <v-icon left>mdi-refresh</v-icon>
              แมตช์ข้อมูลใหม่
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              v-if="userCompany?.isDeveloper || user?.isEngineer"
              color="deep-purple"
              class="tw-tracking-normal tw-text-white"
              @click="openExternalFirebaseLink"
              :disabled="editMode || isUpdating || isRefreshingDoc || isConfirmingDoc"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="1.4em"
                height="1.4em"
                viewBox="0 0 27 27"
              >
                <path
                  fill="currentColor"
                  d="m20 18.69l-7.3 4.05q-.75.39-1.5 0L4 18.69L17.05 5.54l.35-.1c.3 0 .47.13.5.4zM9.35 5.74L4.8 13.29L6.7 1.34c.03-.27.2-.4.5-.4c.2 0 .33.06.4.25l2.15 3.95zM13.85 7L4.3 16.59l7.25-12.3c.1-.2.25-.29.45-.29s.33.09.4.29z"
                />
              </svg>

              <span class="tw-ml-l">ข้อมูลบนคลาวด์</span></v-btn
            >
            <v-btn
              v-if="
                (userCompany?.isDeveloper || user?.isEngineer) &&
                selectedDoc.Status !== poStatus.POSTING
              "
              color="teal"
              class="tw-tracking-normal tw-text-white"
              :loading="isRefreshingDoc"
              :disabled="editMode || isUpdating || isRefreshingDoc || isConfirmingDoc"
                 @click="openRefreshDocument"
            >
              <v-icon left>mdi-cloud-refresh-outline</v-icon>
              ดึงข้อมูลอีกครั้ง</v-btn
            >
            <!-- Download Extracted Text  -->

            <v-btn
              v-if="(userCompany?.isDeveloper || user?.isEngineer)"
              color="blue-grey"
              class="tw-tracking-normal tw-text-white"
              @click="downloadJson(selectedDoc.POID)"
              :disabled="editMode || isUpdating || isRefreshingDoc || isConfirmingDoc"
            >
              <v-icon left>mdi-code-json</v-icon>
              ไฟล์เจซัน</v-btn
            >
            <!-- Download JSON output from ChatGpt  -->
            <v-btn
              v-if="(userCompany?.isDeveloper || user?.isEngineer) "
              color="brown"
              class="tw-tracking-normal tw-text-white"
              @click="downloadExtractedText(selectedDoc.POID)"
              :disabled="editMode || isUpdating || isRefreshingDoc || isConfirmingDoc"
            >
              <v-icon left>mdi-note-text-outline</v-icon>
              ไฟล์ข้อความ</v-btn
            >
            <!-- Download PDF  -->
            <v-btn
              v-if="(userCompany?.isDeveloper || user?.isEngineer)"
              color="indigo"
              class="tw-tracking-normal tw-text-white"
              @click="downloadPdf"
              :disabled="editMode || isUpdating || isRefreshingDoc || isConfirmingDoc"
            >
              <v-icon left>mdi-file-pdf-box</v-icon>
              ไฟล์ PDF</v-btn
            >
            
            <!-- Edit Transaction  -->
            <v-btn
              v-if="selectedDoc.Status !== poStatus.POSTING"
              :disabled="isUpdating || isRefreshingDoc || isConfirmingDoc"
              :color="editMode ? 'error' : 'warning'"
              class="tw-tracking-normal"
              @click="toggleEditMode"
            >
              <v-icon left>mdi-pencil</v-icon>
              {{ editMode ? "ยกเลิก" : "แก้ไข" }}
            </v-btn>
            <!-- Update button -->
            <v-btn
              v-if="editMode"
              :disabled="isUpdating || isDocUnchanged"
              color="info"
              class="tw-tracking-normal"
              @click="updateDocument"
            >
              <v-icon left>mdi-content-save</v-icon>
              {{ isUpdating ? "กำลังบันทึก" : " บันทึก" }}
            </v-btn>
            <v-btn
              color="#cbd5e1"
              v-if="!editMode"
              :disabled="isUpdating"
              class="tw-tracking-normal"
              @click="
                () => {
                  isOpenCustomDialogue = false;
                  isJustUpdateGlblNumLoc = false;
                }
              "
            >
              <v-icon left>mdi-close</v-icon>
              ปิด</v-btn
            >
          </div>
        </div>
      </div>
    </v-main>
    <v-snackbar
      timeout="2500"
      v-model="snackbar.show"
      :color="snackbar.color"
      top
    >
      <v-icon v-if="snackbar.icon" left>{{ snackbar.icon }}</v-icon>
      {{ snackbar.msg }}
    </v-snackbar>
    <v-dialog v-model="exportDialog" persistent max-width="400px">
      <v-form ref="form">
        <v-card>
          <v-card-title>
            <b>ส่งออกข้อมูล</b>
          </v-card-title>
          <v-card-text class="tw-pb-0">
            <v-menu
              v-model="menuDatePickerStart"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  outlined
                  dense
                  v-model="dateExportStart"
                  label="วันที่เอกสารเริ่มต้น"
                  append-icon="mdi-calendar"
                  persistent-placeholder
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="dateExportStart"
                @input="menuDatePickerStart = false"
              ></v-date-picker>
            </v-menu>
            <v-menu
              v-model="menuDatePickerEnd"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  outlined
                  dense
                  v-model="dateExportEnd"
                  persistent-placeholder
                  label="วันที่เอกสารสิ้นสุด"
                  append-icon="mdi-calendar"
                  :disabled="!dateExportStart"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="dateExportEnd"
                :allowed-dates="
                  (date) => new Date(date) >= new Date(dateExportStart)
                "
                @input="menuDatePickerEnd = false"
              ></v-date-picker>
            </v-menu>
            <v-select
              v-model="exportDocStatus"
              :items="statusOptions"
              label="สถานะเอกสาร"
              v-on:change="handleStatusSearch"
              outlined
              dense
            ></v-select>
          </v-card-text>
          <v-card-actions>
            <v-btn text @click="cancelExportDocs">
              <v-icon>mdi-close-circle-outline</v-icon>
              <b>ยกเลิก</b>
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              text
              color="#6ec39b"
              type="button"
              class="btn-submit"
              :disabled="!dateExportStart || !dateExportEnd"
              @click="exportDocs"
            >
              <b>ส่งออกข้อมูล</b>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </Admin>
</template>

<style lang="scss" scoped>
* {
  --warning-color: rgb(255, 178, 76);
  --warning-bg-color: rgb(255, 178, 77, 0.2);
  --error-color: rgb(173, 15, 1);
  --error-bg-color: rgb(173, 15, 1, 0.2);
  --pending-color: rgb(97, 163, 255);
  --pending-bg-color: rgba(97, 163, 255, 0.2);
  --posting-color: rgb(159, 152, 255);
  --posting-bg-color: rgba(159, 152, 255, 0.2);
  --fetching-color: #777a82;
  --fetching-bg-color: rgba(119, 122, 130, 0.2);
  --new-color: #4794eb;
  --new-bg-color: rgba(71, 148, 235, 0.2);
  --text-color: #ffffff;
  --success-color: #0fb45f;
  --success-bg-color: rgba(15, 180, 95, 0.2);
}

.custom-button {
  cursor: pointer;
  /* border: 2px solid red; */
  padding: 0.5rem 1rem;
}

.custom-button:active {
  opacity: 50%;
}

.error-color {
  color: var(--error-color);
  background-color: var(--error-bg-color);
  display: inline-block;
}

.success-color {
  color: var(--success-color);
  background-color: var(--success-bg-color);
  display: inline-block;
}

.warning-color {
  color: var(--warning-color);
  background-color: var(--warning-bg-color);
  display: inline-block;
}

.fetching-color {
  color: var(--fetching-color);
  background-color: var(--fetching-bg-color);
  display: inline-block;
}

.pending-color {
  color: var(--pending-color);
  background-color: var(--pending-bg-color);
  display: inline-block;
}
.new-color {
  color: var(--new-color);
  background-color: var(--new-bg-color);
  display: inline-block;
}

.posting-color {
  color: var(--posting-color);
  background-color: var(--posting-bg-color);
  display: inline-block;
}

.status-card {
  border-radius: 1rem;
  padding: 0.4rem 1rem;
  text-align: center;
  font-weight: bold;
  max-width: 200px;
}
.status-card-dialogue {
  border-radius: 1rem;
  padding: 0.4rem 1rem;
  text-align: center;
  font-weight: bold;
  font-size: 1rem;
}
/* Additional styling for the table */
.table-container {
  width: 100%; /* Adjust the width as needed */
  overflow-x: auto;

  td,
  th {
    white-space: nowrap;
  }
}

.table-container-detail {
  width: 100%; /* Adjust the width as needed */

  td,
  th {
    white-space: wrap;
    font-weight: 500;
  }
}
.customer-table-detail {
  width: calc(100% - 2.7rem);
  /* border: 2px solid red; */
}

/* Styling for table headers */
.customer-table-detail th {
  padding: 10px;
  text-align: left;
}

/* Styling for table cells */
.customer-table-detail td {
  padding: 10px;
  height: 40px;
  border: 1px solid rgba(182, 182, 182, 0.528);
}

/* Styling for table rows */
.customer-table-detail tbody tr {
  padding: 10px; /* Add padding to each row */
}
.customer-table-detail tbody {
  border-bottom: 2px solid rgb(182, 182, 182);
}
.customer-table-detail tbody:hover {
  background-color: #f2f2f27b;
  cursor: pointer;
}
.customer-table-detail tbody:active {
  background-color: #cac8c87b;
  cursor: pointer;
}

/* ---------------------- */

.table-toolbar {
  padding: 1rem;
}

.custom-table {
  border-collapse: collapse;
  width: 100%; /* Make table width 100% of container */
  overflow: hidden;
}

/* Styling for table headers */
.custom-table th {
  padding: 0 10px;
  text-align: left;
  white-space: nowrap; /* Prevents text wrapping */
  height: 60px;
  border-bottom: 1px solid rgb(182, 182, 182);
  font-weight: 500;
}

/* Styling for table cells */
.custom-table td {
  padding: 0 10px;
  text-align: left;
  white-space: nowrap; /* Prevents text wrapping */
}

/* Styling for table rows */
.custom-table tbody tr {
  border-bottom: 1px solid #e6e6e6;
  padding: 0 10px; /* Add padding to each row */
  height: 3rem; /* Add height to each row */
}

.custom-table tbody tr:hover {
  background-color: #f2f2f27b;
  cursor: pointer;
}

.custom-table tbody tr:active {
  background-color: #cac8c87b;
  cursor: pointer;
}

.custom-dialogue {
  position: fixed;
  z-index: 99;
  padding: 1.5rem;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.4);
  transition: all 0.3s;
}

.custom-dialogue-content-wrapper {
  padding: 1rem;
  background-color: #f9f9f9;
  border-radius: 1rem;
  height: 100%;
  width: 100%;
  /* border: 5px solid green; */
}

.dialog-header-wrapper {
  /* border: 2px solid green; */
  height: 2.7rem;
}

/* Default styles for .dialog-content-wrapper */
.dialog-content-wrapper {
  /* border: 2px solid red; */
  display: flex;
  padding: 8px 0px;
  height: calc(100% - 2.7rem * 2);
  width: 100%;
}

.dialog-content-left {
  /* border: 2px solid red; */
  width: 40%;
}

.dialog-content-right {
  /* border: 2px solid green; */
  flex: 1;
}

@media (max-width: 947px) {
  .dialog-content-wrapper {
    flex-direction: column;
  }

  .dialog-content-left {
    width: 100%;
    height: 40%;
  }

  .dialog-content-right {
    /* border: 2px solid green; */
    height: calc(60% - 2.7rem);
  }
}

.dialog-footer-wrapper {
  /* border: 2px solid blue; */
  height: 2.7rem;
}

@media screen and (max-width: 947px), screen and (orientation: portrait) {
  .dialog-content-wrapper {
    flex-direction: column;
  }

  .dialog-content-left {
    width: 100%;
    height: 40%;
    margin-bottom: 1rem;
  }

  .dialog-content-right {
    width: 100%;
    height: auto;
    overflow-y: auto;
  }
}

.duppBox {
  color: rgb(241, 157, 0);
  border: 2px solid rgb(241, 157, 0);
  background: white;
  font-weight: bold;
}

.duppBox p {
  color: rgb(241, 157, 0);
}

.errBox {
  color: rgb(202, 27, 0);
  border: 2px solid rgb(202, 27, 0);
  background: white;
  font-weight: bold;
}

.errBox p {
  color: rgb(202, 27, 0);
}
</style>
